export const ProjectsPage = (props) => {
  return <div>projects</div>;
};
